import * as Yup from 'yup'
export const cancelSaleSchema = () => {
  return Yup.object().shape({
    status: Yup.number().required('Selecione um motivo'),
    observation: Yup.string().min(5, 'Minimo de 5 caracteres').required(),
  })
}
